/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Deleted
 */
export interface Deleted {}

/**
 * Check if a given object implements the Deleted interface.
 */
export function instanceOfDeleted(value: object): boolean {
    return true;
}

export function DeletedFromJSON(json: any): Deleted {
    return DeletedFromJSONTyped(json, false);
}

export function DeletedFromJSONTyped(json: any, ignoreDiscriminator: boolean): Deleted {
    return json;
}

export function DeletedToJSON(value?: Deleted | null): any {
    return value;
}
